/* eslint-disable no-console */
import { useEffect, useRef } from 'react';
import createFonemaCallEvent from '../utils/fonemaCallEventService';

/**
 * Hook específico para manejar el evento onIncomingCallsDrained del SDK de Fonema.
 *
 * Se dispara cuando se han drenado todas las llamadas entrantes.
 * - Limpia referencias globales si corresponde.
 * - Cierra el componente de llamada si está montado.
 */
const useFonemaOnIncomingCallsDrained = ({ incomingPhones, onClose, enabled = true }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const incomingPhonesRef = useRef(incomingPhones);
  incomingPhonesRef.current = incomingPhones;

  useEffect(() => {
    if (!enabled) return undefined;

    let unsubscribeIncomingCallsDrained;

    if (window.FonemaWhatsappAudio?.onIncomingCallsDrained) {
      console.log('Subscribing to onIncomingCallsDrained event (useFonemaOnIncomingCallsDrained)');
      unsubscribeIncomingCallsDrained = window.FonemaWhatsappAudio.onIncomingCallsDrained(
        (callId) => {
          console.log('All incoming calls have been drained', callId);
          if (incomingPhonesRef.current.some((call) => call.callId === callId)) {
            const callInfoData = incomingPhonesRef.current.find((call) => call.callId === callId);
            createFonemaCallEvent({
              callData: callInfoData,
              customerId: callInfoData?.customer?.id,
              endedReason: 'user-drained-calls',
              status: 'missed'
            });
          }
          if (typeof onCloseRef.current === 'function') {
            onCloseRef.current(callId);
          }
        }
      );
    }

    return () => {
      console.log(
        'Cleaning up onIncomingCallsDrained listener in useFonemaOnIncomingCallsDrained'
      );
      if (
        unsubscribeIncomingCallsDrained
        && typeof unsubscribeIncomingCallsDrained === 'function'
      ) {
        console.log('Unsubscribing from onIncomingCallsDrained event');
        unsubscribeIncomingCallsDrained();
      }
    };
  }, [onCloseRef, incomingPhonesRef, enabled]);
};

export default useFonemaOnIncomingCallsDrained;
